import React, { useState } from "react";
import PriceListHome from "./PriceListHome";
import PriceCatalogUploadPage from "./PriceCatalogUploadPage";
import PriceListUploadPage from "./PriceListUploadPage";

const PriceList = () => {
  const [showCatalogUpload, setShowCatalogUpload] = useState(false);
  const [showPriceListUpload, setShowPriceListUpload] = useState(false);
  const [catalogRecords, setCatalogRecords] = useState([]);
  const [priceListRecords, setPriceListRecords] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const handleBackToHome = () => {
    setShowCatalogUpload(false);
    setShowPriceListUpload(false);
  };

  const handleSaveCatalog = (record) => {
    setCatalogRecords((prev) => [record, ...prev]);
    setShowCatalogUpload(false);
  };

  const handleSavePriceList = (record) => {
    setPriceListRecords((prev) => [record, ...prev]);
    setActiveTab(1);
    setShowPriceListUpload(false);
  };

  return (
    <>
      {!showCatalogUpload && !showPriceListUpload && (
        <PriceListHome
          onUploadPriceCatalog={() => setShowCatalogUpload(true)}
          onUploadPriceList={() => setShowPriceListUpload(true)}
          catalogRecords={catalogRecords}
          priceListRecords={priceListRecords}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      )}

      {showCatalogUpload && (
        <PriceCatalogUploadPage onBack={handleBackToHome} onSave={handleSaveCatalog} />
      )}

      {showPriceListUpload && (
        <PriceListUploadPage onBack={handleBackToHome} onSave={handleSavePriceList} />
      )}
    </>
  );
};

export default PriceList;
